export class UpdateRestoreAccountResponse {
    'restoreAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccount",
            "baseName": "restoreAccount",
            "type": "RestoreAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateRestoreAccountResponse.attributeTypeMap;
    }
    constructor() {
    }
}
